export default __webpack_public_path__ + "b996fd04390ddfa9ee869067a837a7c0.svg";